/**
 * Angular imports.
 */
import { Component, EventEmitter, Input, Output, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
/**
 * Service imports.
 */
import { AnalyticsEventService } from '../../analytics-event/analytics-event.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { FileUploadService } from '../../dataservices/file-upload.service';
import { GetService } from '../../dataservices/get.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { GenericResponse, CommunityMembersResponse, CommunityDetailResponse } from '../../onboarding/interface/apiResponse.model';
import { Community, CommunityMember, Member } from '../../onboarding/interface/global.model';
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
/**
 * Constant import.
 */
import { ACTION_ON, ACTION_TYPE, COMMUNITY_MEMBERS_ACTION, CTA_TYPE, IS_SUGGESTION, MEMBERS_LIMIT, MEMBERS_LIST_TYPE, NUMBERS, PRODUCT_TYPE_CONSTANT, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from '../../constants/app.constants';
import { CreateCommunityService } from '../create-community/create-community.service';

/**
 * SDK imports
 */
import { Analytics } from 'analytics2.0';


/**
 * Check box selection card popup.
 */
@Component({
  selector: 'app-community-member-list',
  templateUrl: './community-member-list.component.html',
  styleUrls: ['./community-member-list.component.scss']
})
export class CommunityMemberListComponent implements OnInit, OnChanges, OnDestroy {

  /**
   * Check if modal is open/close.
   * Popup label.
   * Array Length
   * total selected item length.
   * Max number can be selected.
   * Selection complete button disabled or not.
   * Selection complete label.
   * Show Mobile Back Button Flag for Members
   */
  @Input() isCheckBoxModalOpen = true;
  @Input() popupLabel = '';
  @Input() selectedListLength = NUMBERS.ZERO;
  @Input() selectedLimit = NUMBERS.TEN;
  @Input() isButtonDisable = false;
  @Input() completeSelectionLabel = '';
  @Input() showMobileBackButton = false;
  @Input() callingFrom: string;
  @Input() existingCount: number;
  /**
   * Member count of community.
   */
  /**
   * Check if speciality popup is open.
   */
  @Input() isSpecialitySelectionOpen: boolean;

  /**
   * Mobile Back Button Flag for Members Popup
   */
  public mobileBackButtonFlag = false;

  /**
   * Emit the selected event outside.
   * Emit the close popup event outside.
   * Emiitting the count.
   * * Emit back click
   * Emit the event for selected members
   * Emit the event for cancel button clicked
   * Emit for calling add/remove api
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() emitSelected: EventEmitter<any> = new EventEmitter();
  @Output() emitCloseClicked: EventEmitter<void> = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onOriginalBack: EventEmitter<boolean> = new EventEmitter();
  @Output() emitBackToSuggestions: EventEmitter<string> = new EventEmitter();
  @Output() emitSelectedarray: EventEmitter<Member[]> = new EventEmitter();
  @Output() emitCancelClicked: EventEmitter<boolean> = new EventEmitter();
  @Output() emitUpdateMembers: EventEmitter<boolean> = new EventEmitter();

  /**
   * List for members
   * Check members selection open/close.
   * Check members view all enable or not
   * define search type
   * defining member keyword
   * List for preselected members
   * check for mobile back button flag
   * show existing user flag
   * check for member concat
   * member count for total members
   * define community data
   * list for members selection removal
   * placeholder for filter
   * selection label
   * pop up label
   * max limit for members
   * defining offset
   * Id for community
   * search subject
   * array length
   * cancel pop up flag
   * numbers from constant
   */
  //TODO : Add Typing
  public selectedMembers = [];
  public isMembersSelectionOpen = false;
  public membersIsViewAllEnable = false;
  public membersSearchType = MEMBERS_LIST_TYPE.CONNECTION;
  public membersIsSuggestion = IS_SUGGESTION.YES;
  public membersKeyword = '';
  public preSelectedMembersList = [];
  public originalSelectedMembersList = [];
  public showMobileBackButtonFlag = false;
  public showExistingUsersFlag = false;
  public isMemberConcat = true;
  //TODO : Add Typing
  public memberCount: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public communityData: any = {};
  public membersSelectedRemoved = [];
  public membersFilterPlaceholder = this.mls.languageText.community.key26;
  public membersSelectionLabel = this.mls.languageText.community.key12;
  public membersPopupLabel = `${this.mls.languageText.community.key16} ${this.mls.languageText.community.key19}`;
  public membersNoDataFoundLabel = this.mls.languageText.community.key17;
  public membersSelectedTitle = this.mls.languageText.community.key18;
  public membersSelectedLimit = MEMBERS_LIMIT;
  public membersTitle = this.mls.languageText.community.key19;
  public membersMaxLimitErrorLabel = this.mls.languageText.community.key14;
  public offset: number;
  public communityId: string;
  public search: Subject<string> = new Subject();
  public selectedLength = NUMBERS.ZERO;
  public cancelPopUp = false;
  public numbers = NUMBERS;
  /**
   * Analytics session time.
   * state for flow
   * state for review
   * defining member list
   * defining member array
   * display count for count of members
   */
  private sessiontime = { 'start_time': '', 'end_time': '' };
  private subscriptions: Subscription = new Subscription();
  public communityDetail: Community;
  public clicked = NUMBERS.ZERO;
  public reviewState = NUMBERS.ONE;
  public memberList: CommunityMember[];
  public memberArray: Member[] = [];
  public displayCount: number;

  public startTime = new Date().getTime()

  constructor(
    public mls: NewLanguageService,
    public dss: DataStorageService,
    public getApiService: GetService,
    public fcs: FunCollectionService,
    public route: ActivatedRoute,
    public fileus: FileUploadService,
    private postService: PostApiService,
    public router: Router,
    private analyticsEventService: AnalyticsEventService,
    private analyticSdk: Analytics,
    public createCommunityService: CreateCommunityService,
  ) {
    this.communityId = this.route.snapshot.params['communityId'];
  }

  ngOnInit(): void {
    if (this.callingFrom === SCREEN_NAME.COMMUNITY_EDIT_PAGE && this.communityId) {
      this.clicked = NUMBERS.ONE;
    }
  }


  /**
   * Set the selected button disable/Enable.
   */
  setIsButtonDisable(condition): void {
    if (condition) {
      this.isButtonDisable = true;
    } else {
      this.isButtonDisable = false;
    }
    if (this.callingFrom === SCREEN_NAME.COMMUNITY_EDIT_PAGE && this.communityId) {
      this.clicked = NUMBERS.ONE;
    }
  }

  /**
   * Emit when popup is hide.
   */
  onCheckBoxModalHidden(): void {
    this.isCheckBoxModalOpen = false;
    this.emitCloseClicked.emit();
  }

  /**
   * Emit when selection is complete.
   */
  selectionComplete(): void {
    if (this.reviewState === NUMBERS.ONE) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
        this.communityDetail?.da_id ?? '0', SCREEN_NAME.COMMUNITY_MEMBER_REVIEW, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.DONE, null);
    }
    else if (this.reviewState === NUMBERS.TWO) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
        this.communityDetail?.da_id ?? '0', SCREEN_NAME.COMMUNITY_ADD_MEMBERS, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REMOVE_COMMUNITY_MEMBER_CONFIRM, null);
    }
    this.emitSelected.emit(this.membersSelectedRemoved);
    if (this.communityId && this.callingFrom === SCREEN_NAME.COMMUNITY_EDIT_PAGE) {
      this.emitSelectedarray.emit(this.memberArray);
    }
    if (this.communityId && this.callingFrom === SCREEN_NAME.COMMUNITY_DETAILS) {
      this.emitSelectedarray.emit(this.memberArray);
    }
  }

  /**
   * On Changes
   */
  ngOnChanges(): void {
    if (!this.memberCount) {
      this.memberCount = NUMBERS.ZERO;
    }
    this.mobileBackButtonFlag = this.showMobileBackButton;
    // this.memberCount = this.memberCount;

  }

  /**
   * Show Original Members List from Existing or Selected
   */
  showOriginalList(): void {
    this.mobileBackButtonFlag = false;
    this.onOriginalBack.emit(false);
  }

  /**
   * open Members popup.
   */
  openMembersPopup(): void {
    if (this.selectedMembers.findIndex(index => index.custom_id === this.createCommunityService.loggedInUser.custom_id) === NUMBERS.MINUS_ONE) {
      this.selectedMembers.push(this.createCommunityService.loggedInUser);
    }
    this.membersIsViewAllEnable = false;
    this.createCommunityService.membersSuggestionList = [];
    this.membersSearchType = MEMBERS_LIST_TYPE.CONNECTION;
    this.membersIsSuggestion = NUMBERS.ONE;
    this.membersKeyword = '';
    this.createCommunityService.membersSuggestionOffset = NUMBERS.ONE;
    this.createCommunityService.existingMembersSuggestionOffset = NUMBERS.ONE;
    this.callConnectionList(this.isMemberConcat);
    this.isMembersSelectionOpen = true;
    if (!this.communityId && !this.memberCount) {
      this.memberCount = this.selectedMembers.length || NUMBERS.ONE;
    }

    if (this.communityId) {
      this.getMemberCount();
    }
  }

  /**
   * Close member popup.
   */
  closeMembersPopup(): void {
    this.isMembersSelectionOpen = false;
    this.selectedMembers = [...this.preSelectedMembersList];
    this.memberCount = !this.communityId ? undefined : this.communityData['members'].count;
    if (this.communityId || !this.memberCount) {
      this.membersSelectedRemoved = [];
    }
    this.callConnectionList(this.isMemberConcat);
  }

  /**
   * Calling connection list
   */
  callConnectionList(isMemberConcat: boolean): void {
    this.createCommunityService.connectionList(this.membersSearchType, this.createCommunityService.membersSuggestionOffset, this.membersIsSuggestion, this.membersKeyword, {}, isMemberConcat, this.communityId);
  }
  /**
   * Method for calling existing members
   */
  callExistingMemberList(isMemberConcat: boolean): void {
    if (this.createCommunityService.existingMembersSuggestionOffset !== NUMBERS.ZERO || this.createCommunityService.existingMembersSuggestionOffset !== undefined) {
      this.createCommunityService.FetchMemberList(this.membersSearchType, this.createCommunityService.existingMembersSuggestionOffset, this.membersIsSuggestion, this.membersKeyword, {}, isMemberConcat, this.communityId);
    }
  }
  /**
   * Searching in connection list
   */
  searchInConnectionList(keyword: string): void {
    this.createCommunityService.membersSuggestionOffset = NUMBERS.ONE;
    this.createCommunityService.existingMembersSuggestionOffset = NUMBERS.ONE;
    this.membersKeyword = keyword;
    if (this.clicked === NUMBERS.ZERO) {
      this.callConnectionList(this.isMemberConcat);
    }
    if (this.clicked === NUMBERS.ONE || this.clicked === NUMBERS.TWO) {
      this.callExistingMemberList(this.isMemberConcat);
    }
  }
  /**
   * Method for calling existing members
   */
  showExistingMember(): void {
    this.subscriptions.add(this.getApiService.getCommunityMembers(this.membersKeyword, this.communityId, this.createCommunityService.membersSuggestionOffset, '').subscribe((res: CommunityMembersResponse) => {
      if (res.status === NUMBERS.ONE) {
        this.offset = res.data.offset;
        this.memberList = res.data.members;
      }
    }));
  }

  /**
   * going back to member suggestion
   */
  backToMembersSuggestion(): void {
    this.membersIsSuggestion = NUMBERS.ONE;
    this.createCommunityService.membersSuggestionOffset = NUMBERS.ONE;
    this.createCommunityService.existingMembersSuggestionOffset = NUMBERS.ONE;
    this.membersSearchType = MEMBERS_LIST_TYPE.CONNECTION;
    this.membersIsViewAllEnable = false;
    this.callConnectionList(this.isMemberConcat);
  }
  /**
   * Method for updating member count
   */
  checkUncheckMember(event: boolean): void {
    if (!this.memberCount) {
      this.memberCount = NUMBERS.ZERO;
    }
    if (event) {
      this.memberCount = this.memberCount + NUMBERS.ONE;
    } else {
      this.memberCount = this.memberCount - NUMBERS.ONE;
    }
  }

  /**
   * Selected members.
   */
  membersSelected(data): void {
    const index = this.membersSelectedRemoved.findIndex((item) => {
      return item.custom_id === data.custom_id;
    });
    if (index !== -NUMBERS.ONE) {
      this.membersSelectedRemoved.splice(index, NUMBERS.ONE);
    }
    if (data.action === COMMUNITY_MEMBERS_ACTION.ADD) {
      this.membersSelectedRemoved.push(data);
    }
  }
  /**
   * Remove selcted members.
   */
  membersRemoved(data): void {
    const index = this.membersSelectedRemoved.findIndex((item) => {
      return item.custom_id === data.custom_id;
    });
    if (index !== -NUMBERS.ONE) {
      this.membersSelectedRemoved.splice(index, NUMBERS.ONE);
    }
    if (data.action === COMMUNITY_MEMBERS_ACTION.REMOVE) {
      this.membersSelectedRemoved.push(data);
    }
  }

  /**
   * Set the member list.
   */
  setMembers(analyticsStatus: boolean): void {
    if (analyticsStatus) {
      const d = new Date();
      this.sessiontime.start_time = d.getTime().toString();
    }




    if (this.memberCount === undefined) {
      this.memberCount = this.communityData['members'].count;
    }
    if (analyticsStatus && this.communityId && this.membersSelectedRemoved.length && (this.callingFrom === SCREEN_NAME.COMMUNITY_EDIT_PAGE || this.callingFrom === SCREEN_NAME.COMMUNITY_DETAILS)) {
      this.updateCommunity();
    }

  }

  /**
   * On scroll of community member.
   */
  onCommunityMemberScroll(): void {
    if (this.createCommunityService.existingMembersSuggestionOffset > NUMBERS.ONE ) {
      this.callExistingMemberList(!this.isMemberConcat);
    }
  }
  /**
   * For member count
   */
  getMemberCount(): void {
    this.getApiService.getCommunityDetail(this.communityId).subscribe((res: CommunityDetailResponse) => {
      if (res.status === NUMBERS.ONE) {
        this.memberCount = res.data.detail.members.count;
      }
    });
  }
  /**
   * On Member scroll
   */
  onMembersScroll(): void {
    if (this.createCommunityService.membersSuggestionOffset > NUMBERS.ONE) {
      this.callConnectionList(!this.isMemberConcat);
    }
  }
  /**
   * Event for updating member count
   */
  memberSelected(event): void {
    this.communityDetail.members.count = event;
  }

  /**
   * Redirect to community home
   */
  redirectToDetail(): void {
    this.fcs.navigateToCommunityModule();
    const shareProduct = [{
      share_url: '',
      share_contentt: null,
      product_type: PRODUCT_TYPE_CONSTANT.COMMUNITY,
      product_type_id: this.communityDetail.da_id
    }];
    this.fcs.productShare(shareProduct);
  }
  /**
   * For add button clicking
   */
  addMemberClicked(): void {
    this.clicked = NUMBERS.ZERO;
    this.scrollToTop();
    this.createCommunityService.membersSuggestionList = [];
    this.createCommunityService.membersSuggestionOffset = NUMBERS.ONE;
    this.membersKeyword = '';
    this.callConnectionList(this.isMemberConcat);
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.communityDetail?.da_id ?? '0', SCREEN_NAME.COMMUNITY_EXISTING_MEMBER,CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.ADD_COMMUNITY_MEMBER_AGAIN, null);
  }
  /**
   * For remove button clicking
   */
  removeMemberClicked(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.communityDetail?.da_id ?? 0, SCREEN_NAME.COMMUNITY_EXISTING_MEMBER, CTA_TYPE.TEXT, ACTION_TYPE.CLICK, ACTION_ON.REMOVE_COMMUNITY_MEMBER, null);
    this.clicked = NUMBERS.TWO;
    this.reviewState = NUMBERS.TWO;
    this.scrollToTop();
  }
  /**
   * For confirm  button clicking
   */
  confirmListClicked(): void {
    if (this.reviewState === NUMBERS.ONE) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.communityDetail?.da_id ?? '0', SCREEN_NAME.COMMUNITY_ADD_MEMBERS, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REVIEW_AND_PROCEED, null);
    }
    else if (this.reviewState === NUMBERS.TWO) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.communityDetail?.da_id ?? '0', SCREEN_NAME.COMMUNITY_REMOVE_MEMBER, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.REMOVE_MEMBER_REVIEW, null);
    }
    this.clicked = NUMBERS.THREE;
  }

  /**
   * For existing member button clicking
   */
  existingListClicked(): void {
    this.clicked = NUMBERS.ZERO;
    this.reviewState = NUMBERS.ONE;
  }

  /**
   * For cancel button clicking
   */
  clearAllClicked(): void {
    if (!this.communityId) {
      this.clicked = NUMBERS.ZERO;
    }
    if (this.communityId) {
      this.clicked = NUMBERS.ONE;
    }
    this.emitCancelClicked.emit(true);
    this.selectedMembers = [];
    this.cancelPopUp = false;
    this.selectedLength = NUMBERS.ZERO;
    this.memberArray = [];
    this.membersSelectedRemoved = [];
    this.selectedMembers = [];
  }

  /**
   * For back button clicking
   */
  backClicked(): void {
    switch (this.clicked) {
      case NUMBERS.ZERO:
        if (!this.communityId) {
          this.clearAllClicked();
          this.onCheckBoxModalHidden();
        }
        else {
          if (this.callingFrom === SCREEN_NAME.COMMUNITY_EDIT_PAGE) {
            if(this.memberArray?.length > NUMBERS.ZERO){
              this.popUpAppear();
            }
            else {
              this.membersKeyword = '';
              this.createCommunityService.memberList = [];
              this.createCommunityService.existingMembersSuggestionOffset = NUMBERS.ONE;
              this.callExistingMemberList(this.isMemberConcat);
              this.clicked = NUMBERS.ONE;
            }

          }
          else {
          if(this.memberArray?.length > NUMBERS.ZERO){
            this.popUpAppear();
          }
          else {
            this.clearAllClicked();
            this.onCheckBoxModalHidden();
          }
          }
        }
        break;
      case NUMBERS.ONE:
        this.clearAllClicked();
        this.onCheckBoxModalHidden();
        break;
      case NUMBERS.TWO:
        if(this.memberArray?.length > NUMBERS.ZERO){
          this.popUpAppear();
        }
        else {
          this.clicked = NUMBERS.ONE;
        }
        break;
      case NUMBERS.THREE:
        if (this.reviewState === NUMBERS.ONE) {
          this.clicked = NUMBERS.ZERO;
          this.membersKeyword = '';
          this.createCommunityService.membersSuggestionList = [];
          this.createCommunityService.membersSuggestionOffset = NUMBERS.ONE;
          this.callConnectionList(this.isMemberConcat);
        }
        else {
          this.clicked = NUMBERS.TWO;
          this.membersKeyword = '';
          this.createCommunityService.memberList = [];
          this.createCommunityService.existingMembersSuggestionOffset = NUMBERS.ONE;
          this.callExistingMemberList(this.isMemberConcat);
        }
        break;
    }
  }
  /**
   * Scroll to top when list gets empty/small.
   */
  //TODO : Change required no direct access to dom
  scrollToTop(): void {
    const myDiv = document.getElementById('containerDiv');
    if (myDiv)
      myDiv.scrollTop = NUMBERS.ZERO;
  }

  /**
   * For count handling
   */
  selectedMemberLength(event): void {
    this.memberArray = event;
    this.selectedLength = event.length;
    if (!this.communityId) {
      this.emitSelectedarray.emit(this.memberArray);
    }
    if (this.communityId) {
      this.displayCount = this.selectedLength + this.existingCount;
    }
    else {
      this.displayCount = this.selectedLength + this.existingCount - NUMBERS.ONE;
    }
  }

  /**
   * For updating community
   */
  updateCommunity(): void {
    this.createCommunityService.membersApiInProcess = true;
    this.createCommunityService.updateCommunityMember(
      this.membersSelectedRemoved, this.communityId).
      subscribe((res: GenericResponse) => {
        if (!res.status) {
          this.createCommunityService.membersApiInProcess = false;
          this.isCheckBoxModalOpen = true;
          this.isMembersSelectionOpen = true;
          this.fcs.errorHandeler(res);
          this.emitUpdateMembers.emit(false);
          if (this.callingFrom === SCREEN_NAME.COMMUNITY_EDIT_PAGE && this.reviewState === NUMBERS.ONE) {
            this.clicked = NUMBERS.THREE;
          }
          if (this.callingFrom === SCREEN_NAME.COMMUNITY_EDIT_PAGE && this.reviewState === NUMBERS.TWO) {
            this.clicked = NUMBERS.THREE;
          }
          if (this.callingFrom === SCREEN_NAME.COMMUNITY_DETAILS) {
            this.clicked = NUMBERS.THREE;
          }
        } else {
          this.createCommunityService.membersApiInProcess = false;
          this.isCheckBoxModalOpen = false;
          this.preSelectedMembersList = [...this.selectedMembers];
          this.isMembersSelectionOpen = false;
          this.emitUpdateMembers.emit(true);
          this.onCheckBoxModalHidden();
          if (this.callingFrom === SCREEN_NAME.COMMUNITY_EDIT_PAGE) {
            this.clicked = NUMBERS.ONE;
          }
          if (this.callingFrom === SCREEN_NAME.COMMUNITY_DETAILS) {
            this.clicked = NUMBERS.ZERO;
          }
          this.selectedLength = NUMBERS.ZERO;
          this.selectedMembers = [];
          this.membersSelectedRemoved = [];
          this.memberArray = [];
        }
      }, error => {
        this.isMembersSelectionOpen = true;
        this.fcs.errorHandeler(error);
      });
  }


  /**
   * Cancel button clicked
   */
  cancelClicked() : void {
    if(this.memberArray?.length > NUMBERS.ZERO){
      this.popUpAppear();
    }
    else {
      this.onCheckBoxModalHidden();
      this.clearAllClicked()
    }
  }
  
  /**
   * For add button clicking
   */
  popUpAppear(): void {
    this.cancelPopUp = true;
  }
  /**
   * For cancel pop up button clicking
   */
  popUpClose(): void {
    this.cancelPopUp = false;
  }

  /**
   * On destroy hook
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  /**
   * Change the review state
   */
  changeReviewState(): void {
    this.reviewState = NUMBERS.ONE;
  }

  /**
   * Back To suggestion and connection
   */
  backToSuggestion(): void {
    this.emitBackToSuggestions.emit();
  }


}


